<template>
  <div>
    <div class="header">
        <div class="box">
            <div class="L"><a onClick="javascript:history.back(-1)" class="goback"><img src="/static/images_m/goback.png" /></a></div>
            <div class="C"><p>我的考试</p></div>
        </div>
    </div>  
    <div class="clear"></div>
    <div class="hbox"></div>
    <div class="courseBox" style="padding:0">
      <ul class="ul_3">
          <li v-for="(exam,index) in exams" :key="index"  @click="$router.push(`/courview/info/${course._id}`)">
              <div class="L"><img  :src="`${global.remoteIp}/uploads/${exam.picsrc}`"></div>
              <div class="R">
                  <div class="tit">{{exam.title}}</div>
                  <div class="sub">
                      到期时间：{{exam.endtime}}
                  </div>
                  <div class="xx"><span>
                      考试时长：{{exam.duration}}分钟
                      </span><p>{{getExamState(exam.examState)}}</p></div>
              </div>
          </li>
      </ul>
    </div>
    <el-dialog
            :visible.sync="faceVisible"
            :width="faceWidth"
            title="请保持脸部在取景框内"
            :show-close="false"
            center
            >
            <face-live-ex :visibleFlag="faceVisible" v-if="faceVisible" @VerfiyFailed = "faceVisible=false" :examId ="selExams._id" ref="faceBox" @chgWidth="chgWidth($event)" @VerfiyPass="verfiyPass($event)"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="faceVisible = false;" >取 消</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
import FaceLiveEx from "@/components/PublicComs/FaceLiveEx.vue";
import { Message} from "element-ui";
export default {
  data() {
    return {
      global,
      intTotal: 20,
      intCurrent: 1,
      exams: [],
      plateId: "",
      searchType: "",
      paperSubs: [],
      searchWords: "",
      searchSub: "",
      faceWidth: "500px",
      faceVisible: false,
      selExams: {},
    };
  },
  // :to="global.isPhone()?`/exam/${exam._id}`:`/exampc/${exam._id}`"
  components: { FaceLiveEx },

  computed: {},
  watch: {
    searchType(newVal) {
      if (newVal) {
        this.toPage(0);
      }
    },
  },
  mounted() {
    if (this.global.isPhone()) {
      this.faceWidth = "90%";
    }
    this.$axios
      .get(`/api/students/testPapers?page=1&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.exams = res.data.data;
          this.intTotal = res.data.total;
        }
      });
    this.$axios.get("/api/auth/me").then((res) => {
       let arrhasCourse = [];
      for (var i = 0; i <res.data.data.needexaminee.length; i++)
      {
        arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
      }
      this.paperSubs = arrhasCourse;
    });
  },

  methods: {
    enterExam(exam) {
      if(exam.examState=='noStart')
      {
        Message.error(`请在 ${exam.examstarttime}之后进行考试!`);
        return;
      }else if(exam.examState=='usertimeend')
      {
        Message.error(`考试已结束!`);
        return;
      }
      if(exam.endtime)
      {
        if(exam.endtime<this.dateFormat(new Date(),'yyyy-MM-dd'))
        {
          Message.error("学习时间已到期！");
          return;
        }
      }
      if (exam.checkface&&this.$root.ischeckface) {
        this.faceVisible = true;
        this.selExams = exam;
      } else {
        this.selExams = exam;
        this.verfiyPass();
      }
    },
    verfiyPass() {
      this.$router.push(
        this.global.isPhone()
          ? `/exam/${this.selExams._id}`
          : `/exampc/${this.selExams._id}`
      );
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    setSearchSubs(searchSub) {
      this.searchSub = searchSub;
    },
    chgWidth(faceWidth) {
      this.faceWidth = faceWidth;
    },
    toPage(intcount) {
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&papertype=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchSub) {
        searchConditions += "&examinee=" + this.searchSub;
      }
      this.$axios
        .get(
          `/api/students/testPapers?page=${
            this.intCurrent
          }&limit=6&sort=-createdAt${searchConditions}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.exams = res.data.data;
            this.toTop();
          }
        });
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    getExamTimes(times) {
      switch (times) {
        case "0":
          return "不可补考";
        case "1":
          return "可补考一次";
        case "2":
          return "不限次数";
      }
    },
    getTimediff(starttime, endtime) {
      let start = new Date(starttime).getTime();
      let end = new Date(endtime).getTime();
      let time = end - start;
      //计算出相差天数
      var days = Math.floor(time / (24 * 3600 * 1000));

      //计算出小时数

      var leave1 = time % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      return `${hours} : ${minutes} : ${seconds}`;
    },
    NewDate(str) {
      if (!str) {
        return 0;
      }
      let arr = str.split(" ");
      let d = arr[0].split("-");
      let t = arr[1].split(":");
      var date = new Date();
      date.setUTCFullYear(d[0], d[1] - 1, d[2]);
      date.setUTCHours(t[0], t[1], t[2], 0);
      return date;
    },
    getExamState(state) {
      switch (state) {
        case "newStart":
          return "开始考试";
        case "resit":
          return "开始补考";
        case "repeatStart":
          return "重新考试";
        case "continue":
          return "继续考试";
        case "end":
          return "考试结束";
          case "noStart":
          return "未开始";
        case "usertimeend":
          return "考试结束";
        default:
          return "开始考试";
      }
    },
    getExamState1(state) {
      switch (state) {
        case "newStart":
          return "正在考试";
        case "resit":
          return "正在考试";
        case "repeatStart":
          return "正在考试";
        case "continue":
          return "正在考试";
        case "end":
          return "考试完成";
        default:
          return "正在考试";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/style_Phone.scss";
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #51be78;
}
::v-deep .el-pager li.active {
  color: #51be78;
}
.courseBox ul.ul_3 li .R .sub{
  color: #51be78;
}
.courseBox ul.ul_3 li .R .xx span{
  color: #0990e0
}
</style>
